<template>
    <div class="loadingitem" v-if="loading==true">{{waitlabel}}</div>
    <div v-if="currentcaseitem!=null && ismobile==false">
        <cmpcasestudieslarge :caseitemlarge="currentcaseitem"></cmpcasestudieslarge>
    </div>
    <div v-if="currentcaseitem!=null && ismobile==true">
        <cmpcasestudiesmobile :caseitemmobile="currentcaseitem"></cmpcasestudiesmobile>
    </div>
    <h3 v-if="searcherror==true">Error: Item not found</h3>
    <cmpfooter :sticktobottom="sticktobottom"></cmpfooter>
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"
import backendmixin from "../mixins/backendmixin.js"

import cmpcasestudieslarge from "../components/cmpcasestudieslarge.vue"
import cmpcasestudiesmobile from "../components/cmpcasestudiesmobile.vue"
import cmpfooter from "../components/cmpfooter.vue"







export default {
  name: "caseitem",
  mixins:[multilangmixin,backendmixin],
  components:{
    cmpfooter,
    cmpcasestudieslarge,
    cmpcasestudiesmobile
    
  },
  props:{
    
     "lang":String,
        
  },


  data(){
     return {
          "sticktobottom":false,
          "searcherror":false,
          "categoriesready":false,
          "tagsready":false,
          "loading":true
      } 
  },





  created(){
     
      window.$mitter.on("sigcategoriesready",this.fnOnSigCategoriesReady);
      window.$mitter.on("sigtagsready",this.fnOnSigTagsReady);
      window.$mitter.on("sigcasesready",this.fnOnSigCasesReady);
    
      this.fnFetchCategories();
      this.fnFetchTags();
    
  },


  computed:{

     waitlabel()
      {
        return this.fnGetTranslation(this.currentlang, "wait");
      },
     

      currentcaseitem(){
        if (this.cases.length>0)
        {
            return this.cases[0];
        }
        else
        {
          return null;
        }
               
        
      },

      ismobile(){
          if (window.innerWidth>700)
          {
              return false;
          }
          else
          {
              return true;
          }
      }


    

  },

  
  methods:{

      fnOnSigCategoriesReady(){
          //console.log("fnOnSigCategoriesReady");
          this.categoriesready=true;

          if ((this.categoriesready==true) && (this.tagsready==true))
          {
            this.categoriesready=false;
            this.tagsready=false;
            
            this.fnOnSigfilterchanged();
          }

      },

      fnOnSigTagsReady(){
          //console.log("fnOnSigTagsReady");

          this.tagsready=true;

          if ((this.categoriesready==true) && (this.tagsready==true))
          {
            this.fnOnSigfilterchanged();
          }

      },

      fnOnSigCasesReady(){
          //console.log("fnOnSigCasesReady");
  
          this.loading=false;

          if (this.cases.length==1)
          {
            this.searcherror=false;
          }
          else
          {
            this.searcherror=true;
          }
          

          this.fnOnSigPageResized();

      },

      fnOnSigfilterchanged(){

         this.loading=true;
         const wFilter={  
                            "text":"",
                            "category":"",
                            "tag":"",
                            "key":this.fnGetQueryParam("key"),
                            "news":false
                    };        

      

          this.fnFetchCaseStudies(wFilter);

      },


      fnSetTimerResized()
      {
        window.setTimeout(this.fnOnSigPageResized,300);
      },

      fnOnSigPageResized()
      {


          this.sticktobottom=false;

          /*
          
          if (document.body.scrollHeight>window.innerHeight)
          {
            this.sticktobottom=false;
          }
          else
          {
            if (document.body.scrollHeight<1000)
            {
              this.sticktobottom=false;
            }
            else
            {
              this.sticktobottom=true;
            }
            
            
          }
        
          */

          //console.log(this.sticktobottom,document.body.scrollHeight,window.innerHeight);
      },


      

  }



}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


  .loadingitem{
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 10vh;
    font-size: 1.4em;
  } 
 

  .caseitemcontainerlarge {
    
    display: flex;

    justify-content: left;
    flex-wrap: wrap;
    flex-direction: row;

    min-height: 70vh;
    
    

  }


  .caseitemcontainermobile {
    
    display: flex;

    justify-content: left;
    flex-wrap: wrap;
    flex-direction: row;

    min-height: 70vh;
    
    

  }


  
  @media screen and (min-width: 700px)    {
      /*  schermo desktop */

 

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
     
  }


</style>
